import { mapGetters } from 'vuex'
import { EU_REGION_COUNTRIES_REGEX } from '@/helpers/constants'

export default {
	computed: {
		...mapGetters({
			appAreaConfig: 'location/getAppAreaConfig',
			appTheme: 'getAppTheme',
			countryCode: 'getCountryCode',
		}),

		IS_DARK_THEME() {
			return ['dark', 'navy'].includes(this.appTheme)
		},

		AREA() {
			const { appArea } = this.appAreaConfig

			const BAU_MAIN = ['main', 'wildcard-main'].includes(appArea)
			const BAU_FEMALE = [
				'female',
				'wildcard-female',
				'female-mediterranean-diet',
				'female-keto-diet',
				'female-menopause-diet',
				'female-al',
				'female-water-balance',
			].includes(appArea)
			const BAU_MALE = ['male', 'wildcard-male', 'male-carnivore-diet'].includes(appArea)
			const BAU_FEMALE_AL = ['female-al'].includes(appArea)
			const BAU = [BAU_MAIN, BAU_FEMALE, BAU_FEMALE_AL, BAU_MALE].some(Boolean)

			const ACTIVITY_MAIN = ['main-activity'].includes(appArea)
			const ACTIVITY_FEMALE = ['activity-female-v2', 'activity-seniors-female'].includes(appArea)
			const ACTIVITY_FEMALE_SENIORS = ['activity-seniors-female'].includes(appArea)
			const ACTIVITY_MALE_SENIORS = ['activity-seniors-male'].includes(appArea)
			const ACTIVITY_MALE = ['activity-male', 'activity-seniors-male'].includes(appArea)
			const ACTIVITY = [ACTIVITY_MAIN, ACTIVITY_FEMALE, ACTIVITY_MALE].some(Boolean)

			const YOGA_MAIN = ['main-yoga', 'main-yoga-g'].includes(appArea)
			const YOGA_FEMALE = ['activity-female-yoga'].includes(appArea)
			const YOGA_FEMALE_AL = ['activity-female-yoga-al'].includes(appArea)
			const YOGA_MALE = ['activity-male-yoga'].includes(appArea)
			const YOGA = [YOGA_MAIN, YOGA_FEMALE, YOGA_FEMALE_AL, YOGA_MALE].some(Boolean)

			const WALKING_MAIN = ['main-walking'].includes(appArea)
			const WALKING_FEMALE = ['activity-female-walking'].includes(appArea)
			const WALKING_FEMALE_AL = ['activity-female-walking-al'].includes(appArea)
			const WALKING_MALE = ['activity-male-walking'].includes(appArea)
			const WALKING_JAPANESE_FEMALE = ['activity-female-walking-japanese'].includes(appArea)
			const WALKING_JAPANESE_FEMALE_V2 = ['activity-female-walking-japanese-v2'].includes(appArea)
			const WALKING_TAI_CHI_FEMALE = ['activity-female-tai-chi-walking'].includes(appArea)
			const WALKING_TAI_CHI_FEMALE_V2 = ['activity-female-tai-chi-walking-v2'].includes(appArea)
			const WALKING_TAI_CHI_FEMALE_AL = ['activity-female-tai-chi-walking-al'].includes(appArea)
			const WALKING_TAI_CHI_MALE = ['activity-male-tai-chi-walking'].includes(appArea)
			const PRINTABLE_WALKING_FEMALE = ['female-printable-walking'].includes(appArea)
			const WALKING = [
				WALKING_MAIN,
				WALKING_FEMALE,
				WALKING_FEMALE_AL,
				WALKING_MALE,
				WALKING_JAPANESE_FEMALE,
				WALKING_JAPANESE_FEMALE_V2,
				WALKING_TAI_CHI_FEMALE,
				WALKING_TAI_CHI_FEMALE_V2,
				WALKING_TAI_CHI_FEMALE_AL,
				WALKING_TAI_CHI_MALE,
				PRINTABLE_WALKING_FEMALE,
			].some(Boolean)

			const YOGA_TAI_CHI_MALE = ['activity-male-tai-chi-yoga'].includes(appArea)
			const MAIN_TAI_CHI_WALKING = ['main-tai-chi-walking'].includes(appArea)

			const PILATES_FEMALE = ['activity-female-pilates'].includes(appArea)
			const PILATES_FEMALE_AL = ['activity-female-pilates-al'].includes(appArea)
			const MAT_PILATES_FEMALE = ['activity-female-mat-pilates'].includes(appArea)
			const SOMATIC_FEMALE = ['activity-female-somatic-yoga'].includes(appArea)
			const ASIAN_PILATES_FEMALE = ['activity-female-asian-pilates'].includes(appArea)

			const CHAIR_WORKOUTS_MALE = ['activity-male-chair-workouts'].includes(appArea)

			const MAIN_PILATES = ['main-pilates'].includes(appArea) // TODO: rename to PILATES_MAIN

			const HIIT_FEMALE = ['activity-female-hiit'].includes(appArea)
			const HIIT_MALE = ['activity-male-hiit'].includes(appArea)

			const CALISTHENICS_MAIN = ['main-calisthenics'].includes(appArea)
			const CALISTHENICS_MALE = ['activity-male-calisthenics'].includes(appArea)
			const CALISTHENICS_FEMALE = ['activity-female-calisthenics'].includes(appArea)

			const MILITARY_MALE = ['military-male'].includes(appArea)

			const MEDITERRANEAN_DIET_FEMALE = ['female-mediterranean-diet'].includes(appArea)

			const KETO_DIET_FEMALE = ['female-keto-diet'].includes(appArea)

			const CORTISOL_DIET_FEMALE = ['female-cortisol-diet'].includes(appArea)

			const MENOPAUSE_DIET_FEMALE = ['female-menopause-diet'].includes(appArea)

			const CARNIVORE_DIET_MALE = ['male-carnivore-diet'].includes(appArea)

			const BARRE_FEMALE = ['female-barre'].includes(appArea)

			const GLP_FEMALE = ['female-glp'].includes(appArea)

			const WATER_BALANCE_FEMALE = ['female-water-balance'].includes(appArea)

			const APPLOVIN = [
				BAU_FEMALE_AL,
				PILATES_FEMALE_AL,
				YOGA_FEMALE_AL,
				WALKING_FEMALE_AL,
				WALKING_TAI_CHI_FEMALE_AL,
			].some(Boolean)

			return {
				BAU,
				BAU_MAIN,
				BAU_FEMALE,
				BAU_FEMALE_AL,
				BAU_MALE,

				ACTIVITY,
				ACTIVITY_MAIN,
				ACTIVITY_FEMALE,
				ACTIVITY_MALE,
				ACTIVITY_FEMALE_SENIORS,
				ACTIVITY_MALE_SENIORS,

				YOGA,
				YOGA_MAIN,
				YOGA_FEMALE,
				YOGA_FEMALE_AL,
				YOGA_MALE,

				WALKING,
				WALKING_MAIN,
				WALKING_FEMALE,
				WALKING_FEMALE_AL,
				WALKING_MALE,
				WALKING_JAPANESE_FEMALE,
				WALKING_JAPANESE_FEMALE_V2,
				WALKING_TAI_CHI_FEMALE,
				WALKING_TAI_CHI_MALE,
				WALKING_TAI_CHI_FEMALE_V2,
				PRINTABLE_WALKING_FEMALE,

				YOGA_TAI_CHI_MALE,
				MAIN_TAI_CHI_WALKING,

				PILATES_FEMALE,
				PILATES_FEMALE_AL,
				MAT_PILATES_FEMALE,
				SOMATIC_FEMALE,
				ASIAN_PILATES_FEMALE,

				CHAIR_WORKOUTS_MALE,

				MAIN_PILATES,

				HIIT_FEMALE,
				HIIT_MALE,

				CALISTHENICS_MAIN,
				CALISTHENICS_MALE,
				CALISTHENICS_FEMALE,

				MILITARY_MALE,

				MEDITERRANEAN_DIET_FEMALE,
				KETO_DIET_FEMALE,
				CORTISOL_DIET_FEMALE,

				MENOPAUSE_DIET_FEMALE,
				CARNIVORE_DIET_MALE,

				BARRE_FEMALE,

				GLP_FEMALE,

				WATER_BALANCE_FEMALE,

				APPLOVIN,
			}
		},

		MAIN_FUNNEL_ROUTE_NAME() {
			return 'survey'
		},

		IS_MAIN_FUNNEL() {
			return this.AREA.BAU_MAIN
		},

		IS_MALE_FUNNEL() {
			return (
				this.AREA.BAU_MALE ||
				this.AREA.ACTIVITY_MALE ||
				this.AREA.YOGA_MALE ||
				this.AREA.WALKING_MALE ||
				this.AREA.WALKING_TAI_CHI_MALE ||
				this.AREA.YOGA_TAI_CHI_MALE ||
				this.AREA.CHAIR_WORKOUTS_MALE ||
				this.AREA.ACTIVITY_MALE_SENIORS ||
				this.AREA.CALISTHENICS_MALE ||
				this.AREA.MILITARY_MALE ||
				this.AREA.CARNIVORE_DIET_MALE
			)
		},
		IS_FEMALE_FUNNEL() {
			return (
				this.AREA.BAU_FEMALE ||
				this.AREA.BAU_FEMALE_AL ||
				this.AREA.ACTIVITY_FEMALE ||
				this.AREA.PILATES_FEMALE ||
				this.AREA.PILATES_FEMALE_AL ||
				this.AREA.MAT_PILATES_FEMALE ||
				this.AREA.YOGA_FEMALE ||
				this.AREA.YOGA_FEMALE_AL ||
				this.AREA.SOMATIC_FEMALE ||
				this.AREA.WALKING_FEMALE ||
				this.AREA.WALKING_FEMALE_AL ||
				this.AREA.WALKING_JAPANESE_FEMALE ||
				this.AREA.WALKING_JAPANESE_FEMALE_V2 ||
				this.AREA.PRINTABLE_WALKING_FEMALE ||
				this.AREA.ACTIVITY_FEMALE_SENIORS ||
				this.AREA.MEDITERRANEAN_DIET_FEMALE ||
				this.AREA.KETO_DIET_FEMALE ||
				this.AREA.CORTISOL_DIET_FEMALE ||
				this.AREA.MENOPAUSE_DIET_FEMALE ||
				this.AREA.BARRE_FEMALE ||
				this.AREA.ASIAN_PILATES_FEMALE ||
				this.AREA.GLP_FEMALE ||
				this.AREA.WALKING_TAI_CHI_FEMALE ||
				this.AREA.WALKING_TAI_CHI_FEMALE_V2 ||
				this.AREA.WALKING_TAI_CHI_FEMALE_AL
			)
		},
		IS_FEMALE_ACTIVITY_ONBOARDING_BUILDER_FUNNEL() {
			return (
				this.AREA.ACTIVITY_FEMALE ||
				this.AREA.PILATES_FEMALE ||
				this.AREA.PILATES_FEMALE_AL ||
				this.AREA.MAT_PILATES_FEMALE ||
				this.AREA.YOGA_FEMALE ||
				this.AREA.YOGA_FEMALE_AL ||
				this.AREA.SOMATIC_FEMALE ||
				this.AREA.WALKING_FEMALE ||
				this.AREA.WALKING_FEMALE_AL ||
				this.AREA.WALKING_JAPANESE_FEMALE ||
				this.AREA.WALKING_JAPANESE_FEMALE_V2 ||
				this.AREA.ACTIVITY_FEMALE_SENIORS ||
				this.AREA.ASIAN_PILATES_FEMALE ||
				this.AREA.WALKING_TAI_CHI_FEMALE ||
				this.AREA.WALKING_TAI_CHI_FEMALE_V2 ||
				this.AREA.PRINTABLE_WALKING_FEMALE ||
				this.AREA.WALKING_TAI_CHI_FEMALE_AL
			)
		},

		IS_BAU_FEMALE_NON_US_EU_BR() {
			return (
				this.AREA.BAU_FEMALE &&
				this.countryCode !== 'us' &&
				this.countryCode !== 'br' &&
				!EU_REGION_COUNTRIES_REGEX.test(this.countryCode)
			)
		},
	},
}
